import { applyNBANaming } from 'modules/ai/nba/utils/transformCampaign';
import { getNewDate, ES_DATE_FORMAT } from 'utils/date';

export const transformListName = (name: string) =>
  `${applyNBANaming(name)} ${getNewDate().format(ES_DATE_FORMAT)}`;
